export default class MainSearch extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);

    this.filterResults = el.querySelector('[data-filter-results]');

    this.events.register(window, 'popstate', e => this.onHistoryChange(e));
  }

  onMount() {
    this.filters = this.query('faceted-filters');
    this.mobileFilters = this.query('faceted-filters-mobile');

    if (this.filters) {
      this.events.register(this.filters.el, 'filter:update', e => {
        const { searchParams } = e.detail;

        this._updateSectionContent(searchParams);

        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      });
    }

    if (this.mobileFilters) {
      this.events.register(this.mobileFilters.el, 'filter:update', e => {
        const { searchParams } = e.detail;

        this._updateSectionContent(searchParams);

        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      });
    }
  }

  onDismount() {
    this.events.unregisterAll();
  }

  onHistoryChange(e) {
    // Sometimes, a user might copy + paste a URL that has a search query in it.
    // Or, they might press 'Enter' to submit the search form.
    // In both cases, we want to preserve that initial state, which can be accessed via
    // `window.location.search` on the "last" press of the "back" button
    // (when state object is empty)
    this._updateSectionContent(e.state
      ? e.state.searchParams
      : window.location.search.substring(1));
  }

  _updateSectionContent(searchParams) {
    const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const newDom = new DOMParser().parseFromString(html, 'text/html');

        this.filterResults.innerHTML = newDom.querySelector('[data-filter-results]').innerHTML;

        this.filters.updateFilters(newDom);
        this.mobileFilters.updateFilters(newDom);
      });
  }
}
